import React, { memo, useState, useMemo, useCallback, useEffect } from 'react';
import { View } from 'react-native';
import { Select, AddButton, FormInput, CTAButton, ActionButton } from '../../../components';

import { THEME, COLOR, __WEB__ } from '../../../../constants/styles';
import { edit as iconEdit } from '../../../../constants/assets';

const AddDeleteSelectSchedule = memo((props) => {
  const [editingName, setEditinName] = useState(false);
  const [autoFocusOK, setAutoFocusOK] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setAutoFocusOK(true);
    }, 300);
  }, []);

  useEffect(() => {
    setEditinName(false);
  }, [props.selectedSchedule, props.schedules]);

  const scheduleOptions = useMemo(() => {
    return (
      props.schedules?.map((s) => ({
        label: s.name,
        id: s.employerSchedulerHoursId,
      })) || []
    );
  }, [props.schedules]);

  const createNewSchedule = useCallback(() => {
    props.onSelectSchedule(null);
  }, [props.onSelectSchedule]);

  const deleteSchedule = useCallback(() => {
    if (props.selectedSchedule) {
      props.onDeleteSchedule(props.selectedSchedule);
    } else {
      props.onResetSchedule();
    }
  }, [props.selectedSchedule, props.onDeleteSchedule, props.onResetSchedule]);

  const handleEditNamePress = useCallback(() => {
    setEditinName(true);
  }, []);
  const cancelEditingName = useCallback(() => {
    setEditinName(false);
    props.onResetScheduleName();
  }, [props.onResetScheduleName]);

  return (
    <View style={{}}>
      <View style={[THEME.basicRow, { flex: 1, zIndex: 1000, alignItems: 'center' }]}>
        <View style={[{ flex: 1, maxWidth: 300 }]}>
          {!!props.selectedSchedule && !editingName ? (
            <Select
              editable={true}
              closeOnSelect={true}
              onFocus={null}
              options={scheduleOptions}
              label={'Schedules'}
              onSelect={props.onSelectSchedule}
              value={props.selectedSchedule}
              webMode={true}
              containerStyle={{ flex: 1, marginRight: 15 }}
              nativeContainerStyle={{ flex: 1, marginRight: 15, paddingTop: 5 }}
            />
          ) : (
            <FormInput
              label={editingName ? 'Change Schedule Name' : 'New Schedule Name'}
              onChangeText={props.onChangeScheduleName}
              containerStyle={{ flex: 1, marginRight: 15 }}
              nativeContainerStyle={{ flex: 1, marginRight: 15, paddingTop: 5 }}
              value={props.name || ''}
              controlled={true}
              autoFocus={autoFocusOK}
            />
          )}
        </View>
        {!props.selectedSchedule ? (
          <CTAButton
            style={{ width: 100, height: 40, marginLeft: 10, paddingVertical: 0 }}
            onPress={deleteSchedule}
            label="Cancel"
          />
        ) : editingName ? (
          <CTAButton
            style={{ width: 100, height: 40, marginLeft: 10, paddingVertical: 0 }}
            onPress={cancelEditingName}
            label="Cancel"
          />
        ) : !props.readOnly ? (
          <>
            <AddButton
              onPress={createNewSchedule}
              containerStyle={{ height: 40, paddingRight: 10 }}
            />
            <AddButton
              minusMode={true}
              onPress={deleteSchedule}
              containerStyle={{ height: 40, paddingRight: 10 }}
            />
            <ActionButton
              source={iconEdit}
              onPress={handleEditNamePress}
              extraStyle={{ width: 17, height: 17, tintColor: COLOR.button }}
            />
          </>
        ) : null}
      </View>
    </View>
  );
});

export default AddDeleteSelectSchedule;
